import mapboxgl from 'mapbox-gl'

import { MAP_CONTROL_LAYER_IDS } from './constants'
import { hasLiveStyle } from './mapTeardown'

/**
 * True when a click at `point` landed on an on-map control (see
 * `MAP_CONTROL_LAYER_IDS`), so the click handler of a layer underneath should bail.
 *
 * Mapbox runs the click listener of every layer under the point, in the order
 * the listeners were registered, and none of them can stop the others. Without
 * this check, closing the procedure chart over an obstacle cluster also expands
 * the cluster and zooms the map in.
 */
export function isMapControlClick(map: mapboxgl.Map, point: mapboxgl.PointLike): boolean {
  if (!hasLiveStyle(map)) return false

  // Querying a layer that is not in the style logs an error, and the controls
  // only exist while a procedure chart is on the map.
  const layers = MAP_CONTROL_LAYER_IDS.filter((id) => map.getLayer(id))
  if (layers.length === 0) return false

  return map.queryRenderedFeatures(point, { layers }).length > 0
}
